import {
  LIST_CUSTOMER_GROUPS,
  GET_CUSTOMER_GROUP,
  DELETE_CUSTOMER_GROUP,
} from '../actions/customerGroupsActions';
import { CustomerGroupApiType } from '../features/Customers/Details/Groups/types';

export type CustomerGroupsReducerActionType = {
  type: string;
  payload: {
    group?: CustomerGroupApiType;
    items?: Array<CustomerGroupApiType>;
    total?: number;
    id?: string;
  };
};

const defaultState = {
  items: [],
  group: null,
  total: 0,
};

const customerGroupsReducer = (
  state = defaultState,
  action: CustomerGroupsReducerActionType
) => {
  switch (action.type) {
    case LIST_CUSTOMER_GROUPS:
      return action.payload;
    case GET_CUSTOMER_GROUP:
      return {
        total: state.total,
        items: state.items,
        group: action.payload.group,
      };
    case DELETE_CUSTOMER_GROUP:
      return {
        total: state.total - 1,
        items: state.items.filter(
          (group: CustomerGroupApiType) => group.id !== action.payload.id
        ),
      };
    default:
      return state;
  }
};

export default customerGroupsReducer;
